<template>
  <v-container>
    <v-row align="center" class="row--35">
      <v-col lg="9" md="9" cols="12">
        <div class="about-inner inner">
          <div class="section-title">
            <h3 class="heading-title" style="font-size: 24px">Health_e Bonus White</h3>
          </div>
          <v-row class="mt--20 mt_sm--10">
            <v-col lg="12" md="12" sm="12" cols="12">
              <div class="about-us-list">
                <h3>
                  ΕΚΠΤΩΣΕΙΣ
                </h3>
                <p class="mr--10"><h3>20% <span class="paragraphSize">  έκπτωση σε όλες τις υπηρεσίες των HealthSpot</span></h3> 
                <p class="mr--10"><h3>15% <span class="paragraphSize">  έκπτωση στα Check up</span></h3> 
                <p class="mr--10"><h3>10% <span class="paragraphSize">  σε όλες τις υπηρεσίες  του ομίλου HHG</span></h3> 
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <!-- <v-col lg="3" md="3" cols="12">
        <div class="thumbnail">
          <slot name="thum-img"></slot>
        </div>
      </v-col> -->
    </v-row>
  </v-container>
</template>
<script>
  export default {
    data () {
      return {
      }
    },
  }
</script>

<style scoped>
.paragraphSize {
  font-size: 16px;
  font-weight: 500;
  font-family: 'PFBagueSansPro-Light';
}

h3{
  font-family: 'PFBagueSansPro-Bold';
}
.v-application p, body p {
    line-height: 1.5;
}
.v-application ul, .v-application ol, body ul, body ol {
    line-height: 1.5;
}
@media only screen and (max-width: 600px) {
  .heading-title-new {
    font-size: 16px !important;
  }
}
</style>